export default ({ href = '/glasses/cartier-eyewear' }) => {
    return (
        <a
            href={href}
            className="cartier-lens-credits-banner"
            style={{
                display: 'flex',
                width: '100%',
                height: 'var(--cartier-banner-height, 88px)',
                boxSizing: 'border-box',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'var(--cartier-banner-gap, 22px)',
                padding: 'var(--cartier-banner-padding, 0 20px)',
                background: '#000',
                color: '#fff',
                textDecoration: 'none',
                overflow: 'hidden',
            }}
        >
            <span className="cartier-lens-credits-banner__brand">
                <img src="/img/cartier-logo-july-2026.svg" alt="Cartier" />
            </span>
            <span className="cartier-lens-credits-banner__copy">
                <span className="cartier-lens-credits-banner__eyebrow">THE LENS CREDIT EVENT</span>
                <span className="cartier-lens-credits-banner__headline">
                    Up to <strong>$750</strong> in lens credits
                </span>
            </span>
            <span className="cartier-lens-credits-banner__image" aria-hidden="true">
                <img
                    src="/img/cartier-lens-credits-july-2026.webp"
                    alt=""
                    style={{
                        width: 'auto',
                        maxWidth: 'none',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                    }}
                />
            </span>
        </a>
    )
}
